import common from "../common";
import Scene from "./Scene";
import Button from "../ui/Button";
import Text from "../ui/Text";

export default class EndScene extends Scene {
    constructor(boutNumber, win, healthArr, playerData, enemyData)
    {
        super('EndScene');

        this.boutNumber = boutNumber;
        this.win = win;
        this.healthArr = healthArr;
        this.playerData = playerData;
        this.enemyData = enemyData;
        this.characterUnlocked = false;

        this.spines = [];

        this.panel = null;
    }

    init()
    {
        super.init('bg');

        var starResult = 0;
        var totalScore = 0;

        if(this.win)
        {
            starResult = 3;
            var totalPossibleScore = common.config.settings.gameFlow.roundPoints * common.config.settings.gameFlow.rounds;
            for(var i in this.healthArr)
            {
                totalScore += Math.round(this.healthArr[i] * common.config.settings.gameFlow.roundPoints);
            }
            
            var starMarks = common.config.settings.gameFlow.starMarks;
            for(var i in starMarks)
            {
                if(totalScore < starMarks[i] * totalPossibleScore)
                {
                    starResult = Number(i)-1;
                    break;
                }
            }
            console.log(totalPossibleScore, totalScore, starResult);
        }

        this.panel = common.display.sprite({asset:'panel_results', anchor:0.5, x:common.STAGE_HALF_WIDTH, y:-200, parent:this});
        
        var tl = new TimelineMax({delay:1, onComplete:() => 
        {
            var count = 0;
            for(var i in this.buttons)
            {
                this.buttons[i].appear(0.2 * count);
                count++;
            }
        }});
        tl.to(this.panel, 0.6, {y:common.STAGE_HALF_HEIGHT, ease:Expo.easeOut});

        var starPositions = [{x:-160, y:-140}, {x:0, y:-200}, {x:160, y:-140}];
        for(let i = 0; i < 3; i++)
        {
            let star = common.display.sprite({asset:'star_' + (i < starResult ? 'on' : 'off'), x:starPositions[i].x, y:starPositions[i].y, alpha:0, scale:1.5, anchor:0.5, parent:this.panel});
            tl.to(star.scale, 0.5, {x:1, y:1, ease:Expo.easeIn, onStart:() => {
                    TweenMax.to(star, 0.4, {alpha:1});
                }, onComplete:() => {
                    if(i < starResult)
                    {
                        var burst = new PIXI.particles.Emitter(this.panel, [P3.assets.texture('sparkle_00')], P3.assets.json('particle_result_star_appear'));
                        burst.emit = true;
                        burst.updateOwnerPos(star.x, star.y);
                        this.particles.push(burst);
                        var tl2 = new TimelineMax();
                        tl2.to(this.panel, .03, {rotation:(-10 - (5*(i-1))) * PIXI.DEG_TO_RAD, ease:Sine.easeInOut});
                        tl2.to(this.panel, .03, {rotation:(10 + (5*(i-1))) * PIXI.DEG_TO_RAD, ease:Sine.easeInOut});
                        tl2.to(this.panel, .7, {rotation:0, ease:Elastic.easeOut});
                        common.audio.playSound(['sfx_char_land_01', 'sfx_char_land_00']);
                    }
                }});
        }

        var scoreTitle = new Text(common.text.translate('score'), {
            font: 50 + "px Lalezar48",
            align: "center"/*,
            tint: 0x000000*/
        });
        scoreTitle.x = 0;
        scoreTitle.y = -70;
        scoreTitle.anchor.set(0.5);
        this.panel.addChild(scoreTitle);

        var scoreText = new Text(String(totalScore), {
            font: 100 + "px Lalezar100",
            align: "center"/*,
            tint: 0x000000*/
        });
        scoreText.x = 0;
        scoreText.y = 0;
        scoreText.anchor.set(0.5);
        this.panel.addChild(scoreText);

        var recordHolder = common.display.container({y:130, parent:this.panel});

        var record = common.saveData.getTopScore(this.boutNumber);

        var trophy = common.display.sprite({asset:'icon_trophy', anchor:0.5, parent:recordHolder});
        var recordText = new Text(String(Math.max(totalScore, record.score)), {
            font: 60 + "px Lalezar48",
            align: "center"/*,
            tint: 0x000000*/
        });
        recordText.x = (trophy.width/2) + 5;
        recordText.y = -10;
        recordText.anchor.set(0, 0.5);
        recordHolder.addChild(recordText);

        recordHolder.x -= recordHolder.width/2;
        recordHolder.x += trophy.width/2;

        if(totalScore > record.score)
        {
            if(record.stars < 3 && starResult == 3 && common.config.settings.gameFlow.unlocks.length > this.boutNumber)
            {
                this.characterUnlocked = true;
            }

            common.saveData.saveTopScore(this.boutNumber, totalScore, starResult);

            TweenMax.to(trophy.scale, 0.3, {x:1.2, y:1.2, yoyo:true, repeat:-1, ease:Sine.easeInOut});
        }

        this.buttons.play = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_primary_large_out'),
            P3.assets.texture('btn_primary_large_over'),
            P3.assets.texture('btn_primary_large_down'),
            P3.assets.texture('icon_play')
        ));
        this.buttons.play.id = 'play';
        this.buttons.play.icon.anchor.set(0.45, 0.53);
        this.buttons.play.x = common.STAGE_HALF_WIDTH + 100;
        this.buttons.play.y = common.STAGE_HEIGHT - 130;
        this.signalListeners.push(this.buttons.play.signals.click.add(this.onButtonClicked, this));
        this.addChild(this.buttons.play);
        
        if(common.currentBout < common.config.settings.gameFlow.enemyOrder.length)
        {
            this.buttons.charSelect = new Button(new P3.ButtonStates(
                P3.assets.texture('secondary_large_character_select_out'),
                P3.assets.texture('secondary_large_character_select_over'),
                P3.assets.texture('secondary_large_character_select_down'),
                P3.assets.texture('character_select_icon')
            ));
            this.buttons.charSelect.id = 'charSelect';
            this.buttons.charSelect.x = common.STAGE_HALF_WIDTH - 100;
            this.buttons.charSelect.y = common.STAGE_HEIGHT - 130;
            this.signalListeners.push(this.buttons.charSelect.signals.click.add(this.onButtonClicked, this));
            this.addChild(this.buttons.charSelect);
        }
        else
        {
            this.buttons.play.x = common.STAGE_HALF_WIDTH;
        }

        this.addHomeButton();

        for(var i in this.buttons)
        {
            this.buttons[i].hide();
        }

        var titleText = new Text(common.text.translate(this.win ? 'wellDone' : 'tryAgain'), {
            font: 60 + "px Lalezar56",
            align: "center"/*,
            tint: 0x000000*/
        });
        titleText.x = common.STAGE_HALF_WIDTH;
        titleText.y = 70;
        titleText.anchor.set(0.5);
        this.addChild(titleText);

        var count = 0;
        var characters = [this.playerData, this.enemyData];
        for(var i in characters)
        {
            var spineData = P3.assets.spineData(characters[i].spine + '_big');
            var spine = new PIXI.spine.Spine(spineData);
            spine.scale.set(0.8);

            spine.skeleton.setSlotsToSetupPose();
            spine.skeleton.setToSetupPose();
            spine.autoUpdate = false;

            if(characters[i].name === '???') spine.tint = 0x000000;

            if(characters[i].skin)
            {
                spine.skeleton.setSkin(spine.spineData.findSkin(characters[i].skin));
            }

            this.spines.push(spine);

            if(count == 0)
            {
                spine.x = common.STAGE_HALF_WIDTH - 300;
            }
            else
            {
                spine.x = common.STAGE_HALF_WIDTH + 300;
                spine.scale.x = -0.8;
            }

            spine.y = common.STAGE_HEIGHT + 30;

            this.addChild(spine);

            count++;
        }

        this.spines[0].state.setAnimation(0, 'body_idle_' + (this.win ? 'victory' : 'lose'), true);
        this.spines[0].state.setAnimation(1, 'legs_idle_' + (this.win ? 'victory' : 'lose'), true);
        this.spines[1].state.setAnimation(0, 'body_idle_' + (this.win ? 'lose' : 'victory'), true);
        this.spines[1].state.setAnimation(1, 'legs_idle_' + (this.win ? 'lose' : 'victory'), true);

        common.audio.playSound('music_results_loop', this.audioLoopParams);

        var allScores = 0;
        for(var i = 0; i < 3; i++)
        {
            allScores += Math.min(common.saveData.data.topScores[i].score, common.config.settings.gameFlow.roundPoints * common.config.settings.gameFlow.rounds);
            /*
            console.log(common.saveData.data.topScores[i].score, common.config.settings.gameFlow.roundPoints * common.config.settings.gameFlow.rounds);
            if(common.saveData.data.topScores[i].score < common.config.settings.gameFlow.roundPoints * common.config.settings.gameFlow.rounds)
            {
                allTop = false;
            }*/
        }
        if(allScores > ((common.config.settings.gameFlow.roundPoints * common.config.settings.gameFlow.rounds) * 3) * 0.98)
        {
            if(common.config.settings.gameFlow.enemyOrder.length == 3)
            {
                common.config.settings.gameFlow.enemyOrder.push('unknown');
                common.config.characters.unknown = {"name":"???", "image":"char_zatana", "colour":"000000", "width":60, "height":160, "speed":1, "stamina":1, "range":1, "power":1, "inertia":0.5, "playable":false, "enemy":true, "projectileSpawn":{"x":0, "y":-110},
                "enemyData":{"intelligence":1, "fireRate":1}};
                if(common.saveData.getTopScore(3) == undefined)
                {
                    common.saveData.data.topScores.push({score:0, stars:0});
                    common.saveData.save();
                }
            }
        }

        if(common.config.characters.unknown)
        {
            common.config.characters.unknown.spine = common.config.characters[common.character].spine;
        }

        if(common.currentBout == 4)
        {
            common.config.characters[common.character].speed = 1;
            common.config.characters[common.character].stamina = 1;
            common.config.characters[common.character].range = 1;
            common.config.characters[common.character].power = 1;
        }
    }

    destroy()
    {
        if(common.currentBout < common.config.settings.gameFlow.enemyOrder.length)
        {
            common.audio.stopSound('music_results_loop');
        }
        super.destroy();
    }

    update()
    {
        super.update();

        for(var i in this.spines)
        {
            this.spines[i].update(P3.Ticker.dt * common.timeStretch);
        }
    }

    resize()
    {
        super.resize();
    }

    onButtonClicked(button)
    {
        this.signals.next.dispatch(button.id, this.characterUnlocked);
    }
}